import axios from 'axios'

export default {
  namespaced: true,
  state: {
    teamInboxTutorialComponent: null,
    usersWithoutTeamInboxAccess: [],
    teamInboxAlertVisible: false
  },
  mutations: {
    SET_TEAM_INBOX_TUTORIAL_COMPONENT (state, ref) {
      state.teamInboxTutorialComponent = ref
    },
    SET_USERS_WITHOUT_TEAM_INBOX_ACCESS (state, users) {
      state.usersWithoutTeamInboxAccess = users
    },
    SET_TEAM_INBOX_ALERT_VISIBLE (state, visible) {
      state.teamInboxAlertVisible = visible
    }
  },
  actions: {
    setTeamInboxTutorialComponent: ({ commit }, ref) => {
      commit('SET_TEAM_INBOX_TUTORIAL_COMPONENT', ref)
    },
    
    async checkUsersWithoutTeamInboxAccess({ commit, rootState }) {
      if (!rootState.cache?.current_company?.team_inbox_enabled) {
        return
      }
      
      try {
        const response = await axios.get('/api/v1/user', {
          params: {
            scope_team_inbox_missing: true,
            paginate: false
          }
        })
        
        const users = response.data || []
        commit('SET_USERS_WITHOUT_TEAM_INBOX_ACCESS', users)
      } catch (error) {
        // Let error bubble up to Sentry for monitoring
        throw error
      }
    },
    
    showTeamInboxAlert({ commit }) {
      commit('SET_TEAM_INBOX_ALERT_VISIBLE', true)
    },
    
    hideTeamInboxAlert({ commit }) {
      commit('SET_TEAM_INBOX_ALERT_VISIBLE', false)
    }
  },
  getters: {
    hasUsersWithoutTeamInboxAccess: state => !!state.usersWithoutTeamInboxAccess?.length,
    usersWithoutTeamInboxAccessCount: state => state.usersWithoutTeamInboxAccess?.length || 0
  }
}
